export const InfluencerReport = {
  get:{
    url: "/partner/report",
    method: ["GET"]
  }
}